import React from 'react';
import { formatTree, createTree as baseCreateTree } from '../../utils';

function createTree(flatData) {
    return baseCreateTree(flatData, {
        idKey: 'rowid',
        pidKey: 'pid',
    });
}

function formatTreeData(tree, callback, config) {
    return formatTree(tree, callback, {
        ...config,
        idKey: 'rowid',
        isLeafKey: 'isleaf',
    });
}

// 树形展开和展开行
export default function useTreeTable(Table) {
    return class TreeTable extends React.Component{
        render(){
            let { treeConfig = {}, columns = [], locale } = this.props;

            let { 
                enable, 
                onExpand,
                expandedKeys = new Set(),
            } = treeConfig;

            let expandIconColumn = [];

            if(enable){
                expandIconColumn = [{
                    title: <div>{locale['table0022'] /*展开*/}</div>,
                    key: 'TREE_ICON',
                    width: 100,
                    fixed: 'left',
                    render: row => {
                        let { isLeaf, depth } = row;
                        // TODO:rowKey生成方式
                        let rowKey = row.rowKey;
                        return !isLeaf && <i 
                            className={`table-row-expand-icon ${expandedKeys.has(rowKey) ? 'table-row-expand-icon-open' : 'table-row-expand-icon-close'}`} 
                            style={{ marginLeft: (depth ?? 0) * 16 }}
                            onClick={() => {
                                if (expandedKeys.has(rowKey)) {
                                    expandedKeys.delete(rowKey);
                                } else {
                                    expandedKeys.add(rowKey);
                                }
                                onExpand?.(expandedKeys);
                            }}
                        ></i>;
                    },
                }];
            }

            columns = expandIconColumn.concat(columns);
            return (
                <Table {...this.props} columns={columns}/>
            );
        }
    };
}

useTreeTable.displayName = 'useTreeTable';
useTreeTable.dependence = [];
useTreeTable.hooks = function() {
    return {
        setTreeData: (treeData, { flat = false } = {}) => {
            let dataMap = {}, { rows } = treeData;

            if (flat) {
                rows = createTree(rows);
            }

            let { nodes, visibleNodes } = formatTreeData(rows, row => {
                row = this._formatRowData(row);
                dataMap[row.rowKey] = row;
                return row;
            }, { expandedKeys: this.store.expandedKeys });

            Object.assign(this.store, { 
                dataMap, 
                rowKeys: 
                nodes.map(node => node.rowKey), 
                visibleRowKeys: visibleNodes.map(node => node.rowKey),
            });

            this.forceUpdate();
        },
        getExpandedKeys: () => {
            return this.store.expandedKeys;
        },
        setExpandedKeys: expandedKeys => {
            this.store.expandedKeys = expandedKeys;

            let { visibleNodes } = formatTreeData(
                createTree(this.getRows()), 
                row => row, 
                { expandedKeys: this.store.expandedKeys, onlyVisible: true },
            );

            Object.assign(this.store, { visibleRowKeys: visibleNodes.map(node => node.rowKey) });

            this.forceUpdate();
        },
    };
};
useTreeTable.propsGenerator = function(props) {
    let { store, treeConfig } = props;
    treeConfig = { 
        ...treeConfig,
        expandedKeys: store.getExpandedKeys(),
        onExpand: expandedKeys => {
            props.treeConfig?.onExpand?.(expandedKeys);
            return store.setExpandedKeys(expandedKeys);
        },
    };
    return {
        ...props,
        treeConfig,
    };
};